<template>
  <div class="modal fade" tabindex="-1" role="dialog" aria-hidden="true" ref="modal">
    <div class="photo-modal modal-dialog modal-lg" role="document" >
      <div class="modal-content">
        <!-- Header -->
        <div class="modal-header border-bottom-0 py-1 relative-position">
          <h5 class="photo-no modal-title text-center w-100" >{{targetPhoto.photo_no}}</h5>
          <img class="btn-close-mg" data-dismiss="modal" src="~assets/close_btn.png">

          <!--<button type="button" class="btn-close rounded-circle" data-dismiss="modal" aria-label="Close">-->
            <!--<i class="fa fa-times" aria-hidden="true"></i>-->
          <!--</button>-->
        </div>
        <!-- 縦長画像 -->
        <!-- 画像 -->
        <div class="modal-body px-1 pt-0 pb-3">
          <div class="row mx-1-gutters">
            <div class="col">
              <div class="photo-image-area" ref="imageAreaFrame">
                <div class="photo-image-wrap" ref="imageAreaWrap" style="position:relative;">
                  <img class="photo-image img-fluid" ref="imageArea" v-lazy="bigThumbnailUrl" >
                </div>
              </div>
            </div>
            <!-- 縦長時の操作UI -->
            <div class="col-4 vertical-operation-flex-wrap" v-if="isVertically" >
              <div class="d-flex flex-column justify-content-end h-100 vertical-operation-flex">
                <div class="text-center pb-3">
                  <button class="btn-favolite btn btn-default px-2" v-if="!isFavorited" @click="addCart" ><trans-text i18nKey="ui['6_1'][1]" :adjustLangFontSizes="{en:0.8}" /> <i class="fa fa-heart" aria-hidden="true"></i></button>
                  <button class="btn-favolite btn btn-danger px-2" v-if="isFavorited" @click="removeCart"><trans-text i18nKey="ui['6_1'][2]" :adjustLangFontSizes="{en:0.8}" /> <i class="fa fa-heart" aria-hidden="true"></i></button>
                </div>
                <div class="clearfix">
                  <button type="button" class="p-0 btn float-left" style="background-color: transparent; color:#82ba1d;" @click="prevImage"><i class="fa fa-arrow-left fa-2x" aria-hidden="true"></i></button>
                  <button type="button" class="p-0 btn float-right" style="background-color: transparent; color:#82ba1d;" @click="nextImage"><i class="fa fa-arrow-right fa-2x" aria-hidden="true"></i></button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 横長時の操作UI -->
        <div class="modal-footer border-top-0 pt-0" v-if="!isVertically">
          <div class="text-left">
            <button type="button" class="btn p-0" style="background-color: transparent; color:#82ba1d;" @click="prevImage"><i class="fa fa-arrow-left fa-2x" aria-hidden="true"></i></button>
          </div>
          <div class="text-center">
            <button class="btn-favolite btn btn-default px-2" v-if="!isFavorited" @click="addCart" ><trans-text i18nKey="ui['6_1'][1]" /> <i class="fa fa-heart" aria-hidden="true"></i></button>
            <button class="btn-favolite btn btn-danger px-2" v-if="isFavorited" @click="removeCart"><trans-text i18nKey="ui['6_1'][2]"  /> <i class="fa fa-heart" aria-hidden="true"></i></button>
          </div>
          <div class="text-right">
            <button type="button" class="btn p-0" style="background-color: transparent; color:#82ba1d;" @click="nextImage"><i class="fa fa-arrow-right fa-2x" aria-hidden="true"></i></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {dd,store,app} from 'systems/imports'
  import Hammer from 'hammerjs'

  export default {
    props: {
      targetPhoto: {},
    },
    components: {
    },
    data () {
      return {
        imageOperation:{
          adjustScale:1,
          adjustDeltaX:0,
          adjustDeltaY:0
        }
      }
    },
    watch:{
    },
    computed:{
      bigThumbnailUrl(){
        let photo = this.targetPhoto
        if(!photo.id){ return '/dist/lodding.gif' }
        //if(!photo.id){ return '/dist/lodding.gif?'+ (new Date()).getTime() }
        let photoThumbnail = app.make("_").find(photo.photo_thumbnails,(photo_thumbnail)=>{
          return (String(photo_thumbnail.type_code) === "2")
        })
        return photoThumbnail.image_url + '?token='+store.get("token")
      },
      borderClass(){
        return this.isFavorited? "redBorder" : "grayBorder"
      },
      isFavorited(){
        return !app.make("_").isEmpty(this.targetPhoto.cart_photos);
      },
      isVertically(){
        let photo = this.targetPhoto
        if(!photo.id){ return null }
        return app.make("_").first(photo.photo_thumbnails).is_vertically || 0
      },
    },
    mounted(){
      this.$nextTick(()=> {
        //ズーム及びピンチ処理
        let image = this.$refs.imageArea
        let webpage = this.$refs.imageAreaWrap

        let mc = new Hammer.Manager(image);

        let pinch = new Hammer.Pinch({threshold: 0});
        let pan = new Hammer.Pan({threshold: 5});
        let tap = new Hammer.Tap();

        pinch.recognizeWith(pan);

        mc.add([pinch, pan,tap]);

        let currentScale = this.imageOperation.adjustScale;
        let currentDeltaX = this.imageOperation.adjustDeltaX;
        let currentDeltaY = this.imageOperation.adjustDeltaY;

        let adjestOverPos = (ev)=>{
          //位置補正
          let imageAreaFrameSize = {width:ev.target.width,hieght:ev.target.height,centerX: ev.target.width / 2, centerY: ev.target.height / 2}
          let imageAreaWrapOffsetPos = {x:0,y:0}

          //画像の中心から左上までの差
          let diffLX =(imageAreaWrapOffsetPos.x - imageAreaFrameSize.centerX)
          let diffLY = (imageAreaWrapOffsetPos.y - imageAreaFrameSize.centerY)

          //中心からの距離
          let dist = Math.sqrt(Math.pow(diffLX,2) + Math.pow(diffLY,2));
          let tan = Math.atan2(diffLY,diffLX);
          //拡大適用後の左上までの差
          let scaleLX = Math.cos(tan) * (dist * currentScale)
          let scaleLY = Math.sin(tan) * (dist * currentScale)
          //小数点第2位で四捨五入
          scaleLX = Math.round(scaleLX * 10) / 10
          scaleLY = Math.round(scaleLY * 10) / 10

          //等倍と現在拡大率での左上の位置の差を計算し、かつ画像を加工枠の要素は等倍のため拡大率で割って調整する
          let limmitOffsetLX = (scaleLX-diffLX) / currentScale
          let limmitOffsetLY = (scaleLY-diffLY) / currentScale
          let limmitOffsetX = Math.abs(limmitOffsetLX)
          let limmitOffsetY = Math.abs(limmitOffsetLY)

          if(currentDeltaX < limmitOffsetLX){currentDeltaX = limmitOffsetLX}
          if(currentDeltaY < limmitOffsetLY){currentDeltaY = limmitOffsetLY}

          if(currentDeltaX > limmitOffsetX){currentDeltaX = limmitOffsetX}
          if(currentDeltaY > limmitOffsetY){currentDeltaY = limmitOffsetY}
        }

        mc.on("tap", (ev)=> {
          let transforms = [];
          currentScale = Math.floor(this.imageOperation.adjustScale +1)
          if(currentScale>3){ currentScale=1 }

          adjestOverPos(ev)
          transforms.push('scale(' + currentScale + ')');
          transforms.push('translate(' + currentDeltaX + 'px,' + currentDeltaY + 'px)');
          webpage.style.transform = transforms.join(' ');

          this.imageOperation.adjustScale = currentScale;
        })

        mc.on("pinch pan", (ev)=> {
          let transforms = [];
          currentScale = this.imageOperation.adjustScale * ev.scale;

          if(currentScale>3){ currentScale=3 }
          if(currentScale<1){ currentScale=1 }
          currentDeltaX = this.imageOperation.adjustDeltaX + (ev.deltaX / currentScale);
          currentDeltaY = this.imageOperation.adjustDeltaY + (ev.deltaY / currentScale);

          adjestOverPos(ev)
          transforms.push('scale(' + currentScale + ')');
          transforms.push('translate(' + currentDeltaX + 'px,' + currentDeltaY + 'px)');
          webpage.style.transform = transforms.join(' ');
        })

        mc.on("panend pinchend",  (ev)=> {
          this.imageOperation.adjustScale = currentScale;
          this.imageOperation.adjustDeltaX = currentDeltaX;
          this.imageOperation.adjustDeltaY = currentDeltaY;
        })

      })


    },
    methods:{
      prevImage(){
        this.$emit("prevImage",this.targetPhoto)

        let webpage = this.$refs.imageAreaWrap
        let transforms = [];
        transforms.push('scale(1)');
        transforms.push('translate(0,0)');
        webpage.style.transform = transforms.join(' ');
        this.imageOperation.adjustScale = 1;
        this.imageOperation.adjustDeltaX = 0;
        this.imageOperation.adjustDeltaY = 0;
      },
      nextImage(){
        this.$emit("nextImage",this.targetPhoto)

        let webpage = this.$refs.imageAreaWrap
        let transforms = [];
        transforms.push('scale(1)');
        transforms.push('translate(0,0)');
        webpage.style.transform = transforms.join(' ');
        this.imageOperation.adjustScale = 1;
        this.imageOperation.adjustDeltaX = 0;
        this.imageOperation.adjustDeltaY = 0;

      },
      addCart(){
        this.$emit("addCarPhoto",this.targetPhoto)
      },
      removeCart(){
        this.$emit("removeCartPhoto",this.targetPhoto)
      }
    }
  }
</script>
<style lang="scss" scoped>
  @import "~scss/_variables";


  .vertical-operation-flex-wrap{
    position: relative;
    .vertical-operation-flex{
      position: absolute; top:0; left:0; bottom: 0; right:0; width:100%; height:100%;
    }

  }

  .btn-favolite{
    @media(max-width: map-get($grid-breakpoints, "lg") - 1) {
      font-size: .6rem !important;
    }
  }

  .modal-footer > div{
    flex-grow: 1;
  }
  .photo-modal{
    .photo-no{
      font-size:1.0rem;
    }
    .photo-image-area{
      overflow:hidden;
      position: relative;
      .photo-image-wrap{
        transform: translate3d(0,0,0);
        transition: transform 0.1s;
        transition-timing-function: ease-in-out;
        transition-property: transform;
        .photo-image{
          max-height: 80vh;
        }
      }
    }

    .btn-close-mg{
      z-index: 1200;
      cursor: pointer;
      width:48px;
      height:48px;
      margin-top: -12px;
      margin-right: -24px;
      @media(min-width: map-get($grid-breakpoints, "lg")) {
        width:64px;
        height:64px;
        margin-top: -16px;
        margin-right: -32px;
      }

    }
    .btn-close{
      background-color: #909090;
      color: #ffffff;
      margin-top: -32px + 4;
      margin-right: -32px;
      width:48px;
      height:48px;
      z-index: 2000;
      position: relative;
      border: none;
      font-size: 2rem;
      font-weight: bold;
      line-height: 1;
      text-shadow: 0 1px 0 #fff;
      cursor: pointer;
    }
  }

</style>



// WEBPACK FOOTER //
// PhotoImageModal.vue?60debd6c